module.exports = __webpack_public_path__ + "media/about/StuffTheBusLogo-d8bdea9a.jpg";